<div [hidden]="!isLoading" class="ion-text-center">
  <ion-spinner color="primary"></ion-spinner> <span>{{ message }}</span>
</div>
